<div class="h-full grid grid-cols-1 grid-rows-[auto_1fr]">
  <app-site-header id="header" />

  <div id="container" class="grid grid-cols-1 overflow-hidden">
    <!-- Toolbar -->
    <header class="bg-primary-500 border-b border-gray-200 dark:border-white/10 dark:bg-gray-900">
      <div class="mx-auto">
        <div class="flex min-h-32 lg:min-h-16 px-4 justify-between">
          <ng-content select="app-toolbar" />
        </div>
      </div>
    </header>

    <div class="flex flex-row overflow-hidden">
      <!-- Sidebar -->
      <nav
        aria-label="Search filters and listings"
        class="w-full md:w-md lg:z-50 2xl:w-3xl dark:bg-gray-900 overflow-y-auto h-full pb-8"
        [class.hidden]="stateService.mobileMapView()"
      >
        <div
          #topOfSideBarListings
          class="flex grow flex-col gap-y-5 border-r border-gray-200 bg-white px-6 pb-32 dark:border-white/10 dark:bg-black/10"
        >
          <ng-content select="app-sidebar" />
        </div>
      </nav>

      <!-- Map -->
      <main
        aria-label="Map"
        [class]="'hidden md:block grow relative ' + backgroundColor()"
        [class.hidden]="!stateService.mobileMapView()"
      >
        <ng-content select="app-map-2" />
      </main>
    </div>
  </div>
</div>
